import {
  BUSINESS_PERFORMANCE_TAB_ID,
  polyFinancialsTabNumber,
  scoreCardTabNumber,
} from 'legacy/lut/components/widgets/public/partner360/ELT/configs'
import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'

interface IPageTitle {
  title: string
  navigationTitle?: string
  subTitle?: string
  showCompanyName?: boolean
  navigationSubTitle?: string
  isToggleable?: boolean
}

type IPageTitles = Record<string, IPageTitle>

export const docStepTitles: IPageTitles = {
  1: {
    title: getFormedEltTranslation('page-doc-1'),
    subTitle: getFormedEltTranslation('page-doc-1-sub-title'),
    navigationTitle: getFormedEltTranslation('page-doc-1-navigation'),
    showCompanyName: true,
  },
  2: {
    title: getFormedEltTranslation('page-doc-2'),
    subTitle: getFormedEltTranslation('page-doc-2-sub-title'),
    navigationTitle: getFormedEltTranslation('page-doc-2-navigation'),
    showCompanyName: true,
  },
  3: {
    title: BUSINESS_PERFORMANCE_TAB_ID,
    subTitle: getFormedEltTranslation('page-business-performance-title'),
    navigationTitle: getFormedEltTranslation('page-business-performance-navigation'),
    showCompanyName: true,
  },
  4: {
    title: getFormedEltTranslation('meetings-page-export'),
    navigationTitle: getFormedEltTranslation('meetings-page-export-navigation'),
    navigationSubTitle: getFormedEltTranslation('meetings-page-export-subtitle'),
  },
}

export const stepTitles: IPageTitles = {
  1: {
    title: getFormedEltTranslation('page-ceo-meetings'),
    subTitle: getFormedEltTranslation('meetings-page-sub-meetings-logistics'),
    navigationTitle: getFormedEltTranslation('meetings-page-sub-meetings-logistics-navigation'),
    showCompanyName: true,
  },
  2: {
    title: getFormedEltTranslation('page-ceo-meetings'),
    subTitle: getFormedEltTranslation('meetings-page-sub-date-time'),
    navigationTitle: getFormedEltTranslation('meetings-page-sub-date-time-navigation'),
    showCompanyName: true,
  },
  3: {
    title: getFormedEltTranslation('page-ceo-meetings'),
    subTitle: getFormedEltTranslation('meetings-page-sub-date-time-2'),
    navigationTitle: getFormedEltTranslation('meetings-page-sub-date-time-2-navigation'),
    showCompanyName: true,
  },
  4: {
    title: getFormedEltTranslation('meetings-page-account-financials'),
    subTitle: getFormedEltTranslation('meetings-page-account-financials-subtitle'),
    navigationTitle: getFormedEltTranslation('meetings-page-account-financials-navigation'),
    showCompanyName: true,
  },
  [polyFinancialsTabNumber]: {
    title: getFormedEltTranslation('poly-financials-page'),
    navigationTitle: getFormedEltTranslation('poly-financials-page-navigation'),
    showCompanyName: true,
  },
  6: {
    title: getFormedEltTranslation('page-ceo-meetings'),
    subTitle: getFormedEltTranslation('meetings-page-sub-date-time-3'),
    navigationTitle: getFormedEltTranslation('meetings-page-sub-date-time-3-navigation'),
    showCompanyName: true,
  },
  7: {
    title: getFormedEltTranslation('meetings-page-account-lastmeeting'),
    subTitle: getFormedEltTranslation('meetings-page-account-lastmeeting-subtitle'),
    navigationTitle: getFormedEltTranslation('meetings-page-account-lastmeeting-navigation'),
    showCompanyName: true,
  },
  [scoreCardTabNumber]: {
    title: getFormedEltTranslation('plc-score-card'),
    subTitle: getFormedEltTranslation('plc-score-card-subtitle'),
    navigationTitle: getFormedEltTranslation('plc-score-card-navigation'),
    showCompanyName: true,
  },
  9: {
    title: getFormedEltTranslation('meetings-page-export'),
    navigationTitle: getFormedEltTranslation('meetings-page-export-navigation'),
    navigationSubTitle: getFormedEltTranslation('meetings-page-export-subtitle'),
  },
}

export const guideTitles: IPageTitles = {
  1: {
    title: getFormedEltTranslation('guide'),
  },
  2: {
    title: getFormedEltTranslation('key-questions'),
  },
}
